module.exports = __webpack_public_path__ + "static/voskos-97d70349b9c2d43d6822036cfa95593b.svg";